/**
 * LTI launch target: when the app is opened as an LTI tool (e.g. in iframe from LMS),
 * the backend may redirect here with token in URL. This page reads token and redirects to callback.
 * Alternatively, the LTI service redirects directly to /lti/callback with token and payload.
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function LtiLaunch() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const payload = searchParams.get('payload');

  useEffect(() => {
    if (token && payload) {
      navigate(`/lti/callback?token=${encodeURIComponent(token)}&payload=${encodeURIComponent(payload)}`, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [token, payload, navigate]);

  return (
    <div className="login-page">
      <div className="login-card">
        <p className="page-muted">Launching from LMS…</p>
      </div>
    </div>
  );
}
